'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Mute = function Mute(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 14 15' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M13.139 4.575h.361a.5.5 0 0 1 .5.5v4.25a.5.5 0 0 1-.5.5h-.361a.5.5 0 0 1-.5-.5v-4.25a.5.5 0 0 1 .5-.5zM1.36 6.225c0-.413.116-.6.544-.6H3.85c.428 0 1.015-.249 1.305-.552l3.207-3.348c.29-.303 1.224-.173 1.315-.173.09 0 .24.036.24.448v11c0 .412-.15.448-.24.448-.091 0-1.026.13-1.315-.173L5.154 9.926c-.29-.303-.877-.551-1.305-.551H1.905c-.428 0-.544-.189-.544-.6v-2.55zM8.885 0C8.458 0 7.87.248 7.58.551L4.455 3.823c-.29.304-.877.552-1.305.552H.856c-.428 0-.856.41-.856.823v4.604c0 .412.428.823.856.823H3.15c.428 0 1.015.248 1.305.552l3.125 3.271c.29.303.878.552 1.305.552H10.5c.427 0 .778-.338.778-.75V.75c0-.412-.35-.75-.778-.75H8.885z'
        }),
        _react2.default.createElement('path', { stroke: 'currentColor', d: 'M13.5 1.5L.467 13.533', strokeLinecap: 'round' })
      )
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Mute;